import { Controller } from '@hotwired/stimulus';
import SlimSelect from 'slim-select'

export default class extends Controller {
  static targets = [ 'searchOption' ]
  // Past maxValuesShown, SlimSelect collapses the selected options into a bare
  // counter, leaving no way to remove them one by one
  static values = { placeholder: String, maxValuesShown: { type: Number, default: 20 } }

  connect() {
    this.slim = new SlimSelect({
      select: this.element,
      settings: {
        showSearch: this.hasSearchOptionTarget,
        placeholderText: this.placeholderValue,
        maxValuesShown: this.maxValuesShownValue
      },
      events: {
        afterChange: (newVal) => {
          if (newVal[0].value === '') this.applyPlaceholderChanges(this.slim.settings.id)
        }
      }
    })

    if (this.slim.getSelected()[0] === '') this.applyPlaceholderChanges(this.slim.settings.id)
  }

  applyPlaceholderChanges = (optionId) => {
    const placeholderIdContainer = document.querySelector(`.ss-main[data-id=${optionId}]`);
    placeholderIdContainer.querySelector('.ss-single').classList.add('vesta-purple-40-important')
  }

  destroy() {
    this.slim.destroy()
  }
}
